import type { GroupSecurity } from '@quromedical/fhir-common';
import { Redirect } from 'expo-router';
import { useUserSession } from 'hooks';

export function withPermissions<P>(
  Component: React.FC<P>,
  permissions: GroupSecurity[],
): React.FC<P> {
  return function WithPermissions(props: P) {
    const session = useUserSession();
    const hasPermission = session.hasAny(permissions);

    if (!hasPermission) {
      return <Redirect href="/" />;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <Component {...props} />;
  };
}
